import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const VirtualBackground = ({
  type,
  ...rest
}: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          id='Icon'
          d='M11.25 3.75h-5.5a2 2 0 0 0-2 2v12.5a2 2 0 0 0 2 2h1.506m12.994-7.5v5.5a2 2 0 0 1-2 2h-1.506m-9.488 0a4.75 4.75 0 0 1 9.488 0m-9.488 0h9.488M14.75 10.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Icon_2'
          d='m19 1.75-1.083 2.167L15.75 5l2.167 1.083L19 8.25l1.083-2.167L22.25 5l-2.167-1.083z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.75 4.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h.84a5.503 5.503 0 0 1 7.773-3.968 5.5 5.5 0 0 1 3.046 3.968h.841c.69 0 1.25-.56 1.25-1.25v-5.5a.75.75 0 0 1 1.5 0v5.5A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75A2.75 2.75 0 0 1 5.75 3h5.5a.75.75 0 0 1 0 1.5zm2.75 6a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19 1a.75.75 0 0 1 .67.415l.972 1.943 1.943.971a.75.75 0 0 1 0 1.342l-1.943.971-.971 1.943a.75.75 0 0 1-1.342 0l-.971-1.943-1.943-.971a.75.75 0 0 1 0-1.342l1.943-.971.971-1.943A.75.75 0 0 1 19 1'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
